<template>
  <div class="mb-6" v-if="documents && documents.length > 0">
    <div v-if="loading">
      <b-skeleton height="72px" :animated="true"></b-skeleton>
      <b-skeleton height="72px" :animated="true"></b-skeleton>
      <b-skeleton height="72px" :animated="true"></b-skeleton>
    </div>

    <div v-else>
      <p class="has-text-weight-bold">
        {{ $t("mp:application.flow.document_prompt.download.title") }}
      </p>

      <div
        v-for="document in documents"
        :key="document.id"
        class="columns document-tile mx-0 my-2"
      >
        <b-icon
          icon-pack="far"
          icon="vote-yea"
          type="is-blue"
          size="is-medium"
          class="mr-2"
        ></b-icon>

        <span class="has-text-blue document-tile-filename">
          {{ document.displayName }}
        </span>

        <div class="ml-auto">
          <span class="cursor-pointer" @click="downloadFile(document)">
            <b-icon
              icon-pack="fa"
              icon="download"
              type="is-blue"
              class="mr-2"
            ></b-icon>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import FileSaver from "file-saver";

export default {
  name: "ApplicationFlowDocumentPromptDownloader",
  props: {
    promptId: {
      type: [String, Number],
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      getFile: "drawer/getFile",
    }),
  },
  data() {
    return {
      isModalOpen: false,
      documents: [],
      loading: false,
    };
  },
  async created() {
    this.loading = true;
    await this.loadDocuments();
    this.loading = false;
  },
  methods: {
    ...mapActions({
      download: "drawer/download",
      downloadMetaData: "drawer/getMerchantMetaData",
    }),
    async loadDocuments() {
      let documents = await this.$store.dispatch(
        "application/fetchPreviousDocuments",
        this.promptId
      );
      if (documents) {
        for (const index in documents) {
          let documentId = documents[index].documentId;
          if (!this.documents.find((document) => document.id === documentId)) {
            let metaData = await this.downloadMetaData(documentId);
            this.documents.push(metaData);
          }
        }
      }
    },
    async downloadFile(document) {
      await this.download(document.id);
      let blob = this.getFile(document.id);
      FileSaver.saveAs(blob, document.fileName);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/colors.scss";

.document-tile {
  background: $grey-2;
  border-radius: 8px;
  padding: 1.5rem;
}

.document-tile-filename {
  padding-top: 0.5rem;
}
</style>
